<template>
<div class="container">
  <div class="row" style="margin-top: 50px;margin-bottom: 5px;">
    <!-- Order Summary Column -->
    <div class="col-md-6">
      <div class="checkout-card order-summary-card">
        <div class="card-header-premium">
          <i class="fas fa-shopping-cart header-icon"></i>
          <div>
            <h4 class="checkout-title">{{$t("message.continue_your_payment")}}</h4>
            <span class="checkout-subtitle">You have {{getShopcard.length}} items not yet paid</span>
          </div>
        </div>
        <div class="card-body-premium">
          <div class="order-items-list">
            <div v-for="(itemcard, index) in getShopcard" :key="index" class="order-item">
              <div class="item-avatar">
                <i class="fas fa-user-circle"></i>
              </div>
              <div class="item-details">
                <span class="item-name">{{itemcard.participant.lastname + ' ' + itemcard.participant.firstname}}</span>
                <span :class="['item-badge', itemcard.apply_for == 1 ? 'badge-new' : 'badge-cpe']">
                  {{ itemcard.apply_for == 1 ? $t("message.new") : "CPE" }}
                </span>
              </div>
              <div class="item-price">
                {{getAmount}} KHR
              </div>
            </div>
          </div>
          
          <div class="divider"></div>
          
          <div class="price-breakdown">
            <div class="breakdown-row">
              <span>Subtotal</span>
              <span>{{getTotalAmount}} KHR</span>
            </div>
            <div class="breakdown-row total-row">
              <span>{{$t("message.total_amount")}}</span>
              <span class="total-price">{{getTotalAmount}} KHR</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Bank Selector Column -->
    <div class="col-md-6">
      <div class="checkout-card bank-selection-card">
        <div class="card-header-premium">
          <i class="fas fa-university header-icon"></i>
          <div>
            <h4 class="checkout-title">សូមជ្រើសរើសធនាគាទូទាត់</h4>
            <span class="checkout-subtitle">Please select your preferred payment bank</span>
          </div>
        </div>
        
        <div class="card-body-premium">
          <div class="bank-options-grid">
            
            <!-- ABA BANK Option -->
            <div 
              class="bank-option-box" 
              :class="{ active: selected_bank === 'aba' }"
              @click="selected_bank = 'aba'"
            >
              <div class="option-selection-indicator">
                <div class="inner-circle"></div>
              </div>
              <div class="option-logo-wrapper">
                <img class="bank-logo aba-bank-logo" src="@/assets/images/aba-web-top-logo.png" alt="ABA BANK">
              </div>
              <div class="option-info">
                <span class="option-title">ABA Bank</span>
                <span class="option-desc">Pay securely via ABA Payway (ABA PAY, KHQR, Cards)</span>
              </div>
              <div class="active-badge" v-if="selected_bank === 'aba'">
                <i class="fas fa-check-circle"></i>
              </div>
            </div>

            <!-- ACLEDA BANK Option -->
            <div 
              class="bank-option-box" 
              :class="{ active: selected_bank === 'acleda' }"
              @click="selected_bank = 'acleda'"
            >
              <div class="option-selection-indicator">
                <div class="inner-circle"></div>
              </div>
              <div class="option-logo-wrapper">
                <img class="bank-logo acleda-bank-logo" src="@/assets/images/acledalogo3.png" alt="ACLEDA BANK">
              </div>
              <div class="option-info">
                <span class="option-title">ACLEDA Bank (កំពុងសាកល្បង)</span>
                <span class="option-desc">Pay securely via ACLEDA x-Pay (x-Pay, KHQR, Cards)</span>
              </div>
              <div class="active-badge" v-if="selected_bank === 'acleda'">
                <i class="fas fa-check-circle"></i>
              </div>
            </div>

          </div>

          <!-- Action buttons -->
          <div class="checkout-actions">
            <router-link class="btn btn-cancel" to="/dashboard/shopping-card">
              <i class="fas fa-arrow-left me-2"></i> {{$t("message.cancel")}}
            </router-link>
            
            <button
              type="button"
              class="btn btn-checkout-premium"
              :disabled="!selected_bank"
              @click="continueToPayment"
            >
              Next <i class="fas fa-arrow-right ms-2"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from "@/axios";
import { mapActions } from 'vuex';
export default {
  setup() {
    return {};
  },
  data() {
    return {
      price: 1200000,
      selected_bank: '',
    };
  },
  methods: {
    showLoader() {
      return this.$loading.show({
        container: this.$refs.formContainer,
        color: "#01B201",
        canCancel: true,
        onCancel: this.onCancelLoader
      });
    },
    ...mapActions([
        'act_shopcard',
    ]),
    continueToPayment() {
      if (this.selected_bank === 'aba') {
        this.$router.push('/aba-payment');
      } else if (this.selected_bank === 'acleda') {
        this.$router.push('/acleda-payment');
      }
    },
    async loadData(){
        this.$store.commit('changeShopcard',[]);
        let loader = this.showLoader();
        await this.act_shopcard();
        loader.hide();
    },
    async loadPrice() {
        try {
            const response = await axios.get("get-price", {
                headers: {
                    Authorization: "Bearer " + this.$store.getters.getAuthToken
                }
            });
            if (response.status === 200) {
                this.price = response.data.data.amount;
            }
        } catch (error) {
            console.error("Error loading price:", error);
        }
    }
  },
  computed :{
    getAmount(){
        return Number((this.price).toFixed(1)).toLocaleString();
    },
    getTotalAmount(){
        const totalAmount = this.$store.getters.getShopcard ? this.$store.getters.getShopcard.length * this.price : 0;
        return Number((totalAmount).toFixed(1)).toLocaleString();
    },
    getShopcard () {
        return this.$store.getters.getShopcard ? this.$store.getters.getShopcard : []
    },
    getParticipant () {
        return this.$store.getters.getParticipant ? this.$store.getters.getParticipant : {}
    }
  },
  created() {
    this.loadPrice();
    if(this.getShopcard.length<=0){
      this.loadData();  
    }
  }
}
</script>

<style scoped>
.checkout-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  border: 1px solid #f1f3f5;
  overflow: hidden;
  margin-bottom: 30px;
  transition: all 0.3s ease;
}

.checkout-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.08);
}

.card-header-premium {
  display: flex;
  align-items: center;
  padding: 20px 24px;
  background: linear-gradient(135deg, #0e8937 0%, #15aa47 100%);
  color: #ffffff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.header-icon {
  font-size: 24px;
  margin-right: 15px;
  color: #ffc107;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.checkout-title {
  font-size: 1.15rem;
  font-weight: 700;
  margin: 0;
  letter-spacing: 0.3px;
}

.checkout-subtitle {
  font-size: 0.85rem;
  opacity: 0.9;
  display: block;
  margin-top: 3px;
}

.card-body-premium {
  padding: 24px;
}

/* Order Summary Details */
.order-items-list {
  max-height: 280px;
  overflow-y: auto;
  padding-right: 5px;
}

.order-items-list::-webkit-scrollbar {
  width: 6px;
}

.order-items-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.order-items-list::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}

.order-item {
  display: flex;
  align-items: center;
  padding: 16px;
  border: 1px solid #f1f3f5;
  border-radius: 12px;
  margin-bottom: 12px;
  background: #f8f9fa;
  transition: all 0.2s ease;
}

.order-item:hover {
  background: #ffffff;
  border-color: #0e8937;
  transform: scale(1.01);
}

.item-avatar {
  font-size: 24px;
  color: #0e8937;
  margin-right: 14px;
  display: flex;
  align-items: center;
}

.item-details {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.item-name {
  font-weight: 600;
  font-size: 0.95rem;
  color: #2b2b2b;
}

.item-badge {
  font-size: 0.72rem;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 20px;
  align-self: flex-start;
  margin-top: 4px;
  text-transform: uppercase;
}

.badge-new {
  background-color: rgba(14, 137, 55, 0.1);
  color: #0e8937;
}

.badge-cpe {
  background-color: rgba(0, 90, 156, 0.1);
  color: #005a9c;
}

.item-price {
  font-weight: 700;
  font-size: 0.95rem;
  color: #2b2b2b;
}

.divider {
  height: 1px;
  background-color: #e9ecef;
  margin: 20px 0;
}

.price-breakdown {
  margin-top: 15px;
}

.breakdown-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  color: #6c757d;
  font-size: 0.9rem;
}

.total-row {
  font-size: 1.15rem;
  font-weight: 800;
  color: #2b2b2b;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed #dee2e6;
}

.total-price {
  color: #0e8937;
  font-size: 1.3rem;
}

/* Bank Selection Options */
.bank-options-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.bank-option-box {
  display: flex;
  align-items: center;
  padding: 18px 20px;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  cursor: pointer;
  position: relative;
  transition: all 0.25s cubic-bezier(0.165, 0.84, 0.44, 1);
  background-color: #ffffff;
}

.bank-option-box:hover {
  border-color: #92e0ab;
  background-color: #fcfefe;
  transform: translateY(-2px);
}

.bank-option-box.active {
  border-color: #0e8937;
  background-color: rgba(14, 137, 55, 0.02);
  box-shadow: 0 4px 15px rgba(14, 137, 55, 0.08);
}

.bank-option-box.disabled {
  opacity: 0.55;
  cursor: not-allowed;
  pointer-events: none;
  background-color: #f8f9fa;
  border-color: #e9ecef;
}

.bank-option-box.disabled:hover {
  transform: none;
  border-color: #e9ecef;
  background-color: #f8f9fa;
}

.option-selection-indicator {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #ced4da;
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.bank-option-box.active .option-selection-indicator {
  border-color: #0e8937;
}

.inner-circle {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: transparent;
  transition: all 0.2s ease;
}

.bank-option-box.active .inner-circle {
  background-color: #0e8937;
}

.option-logo-wrapper {
  margin-right: 20px;
  display: flex;
  align-items: center;
  min-width: 110px;
  justify-content: center;
}

.bank-logo {
  max-height: 48px;
  object-fit: contain;
}

.aba-bank-logo {
  max-height: 75px;
}

.acleda-bank-logo {
  max-height: 42px;
}

.option-info {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.option-title {
  font-weight: 700;
  font-size: 1.05rem;
  color: #2b2b2b;
}

.option-desc {
  font-size: 0.8rem;
  color: #6c757d;
  margin-top: 2px;
}

.active-badge {
  color: #0e8937;
  font-size: 20px;
  display: flex;
  align-items: center;
}

/* Action Buttons */
.checkout-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
  gap: 16px;
}

.btn {
  padding: 12px 24px;
  font-size: 0.95rem;
  font-weight: 700;
  border-radius: 10px;
  transition: all 0.2s ease;
}

.btn-cancel {
  border: 2px solid #e9ecef;
  background-color: #ffffff;
  color: #495057;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}

.btn-cancel:hover {
  background-color: #f8f9fa;
  border-color: #ced4da;
  color: #212529;
}

.btn-checkout-premium {
  background: linear-gradient(135deg, #0e8937 0%, #15aa47 100%);
  color: #ffffff;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 2;
  box-shadow: 0 4px 12px rgba(14, 137, 55, 0.15);
}

.btn-checkout-premium:hover:not(:disabled) {
  background: linear-gradient(135deg, #0b6b2b 0%, #0e8937 100%);
  box-shadow: 0 6px 15px rgba(14, 137, 55, 0.25);
  transform: translateY(-1px);
}

.btn-checkout-premium:disabled {
  background: #ced4da;
  color: #6c757d;
  cursor: not-allowed;
  box-shadow: none;
}

@media (max-width: 768px) {
  .checkout-actions {
    flex-direction: column-reverse;
  }
  .btn-cancel, .btn-checkout-premium {
    width: 100%;
    flex: none;
  }
}
</style>